import { useDispatch, useSelector } from 'react-redux';
import { checkout as legacyCheckout } from '../components/form/actions';
import { selectIsModernCheckout, selectIsMonitoringPurchase } from './checkout-router-selectors';
import { useModernCheckout } from './use-modern-checkout';
import { usePurchaseMonitor } from './use-purchase-monitor';

export const useCheckoutRouter = () => {
  const dispatch = useDispatch();
  const { checkout: modernCheckout } = useModernCheckout();
  const isModernCheckout = useSelector(selectIsModernCheckout);
  const isMonitoringPurchase = useSelector(selectIsMonitoringPurchase);
  const monitor = usePurchaseMonitor();

  const checkout = async () => {
    if (isModernCheckout) {
      await modernCheckout();
    } else {
      dispatch(legacyCheckout());

      if (isMonitoringPurchase) {
        monitor.fireAndForget();
      }
    }
  };

  return { checkout };
};
